import Image from "next/legacy/image";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EmailIcon from "@mui/icons-material/Email";
import TwitterIcon from "@mui/icons-material/X";

import CustomLink from "components/CustomLink";
import Card from "components/Card";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Layout from "components/Layout";

import { members } from "config/members";

const TeamPage = () => {
  return (
    <Layout
      subHeader={{
        header: "UNIQLY TEAM",
        description: "Meet a group of enthusiasts and experts building Uniqly.",
        background: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/subheader/team.jpg`,
        isBackgroundGradient: true,
      }}
    >
      <Box sx={{ mt: { xs: 4, sm: 0 } }}>
        <GridContainer>
          {members.map((member, id) => {
            return (
              <GridItem xs={12} sm={6} md={4} lg={3} key={`member-${id}`}>
                <Card plain>
                  <Box mb={1}>
                    <Image
                      src={member.image}
                      alt={member.name}
                      width="260"
                      height="260"
                    />
                  </Box>
                  <Box maxWidth={{ sm: "260px" }}>
                    <Typography component="h4" variant="h4" color="textPrimary">
                      {member.name}
                    </Typography>
                    <Typography
                      component="h5"
                      variant="h5"
                      paragraph
                      color="textPrimary"
                    >
                      {member.title}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="textPrimary"
                      sx={{ minHeight: "90px" }}
                    >
                      {member.description}
                    </Typography>
                    {member.linkedin && (
                      <CustomLink
                        href={member.linkedin}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <LinkedInIcon sx={{ m: 1, ml: 0 }} fontSize="small" />
                      </CustomLink>
                    )}
                    {member.twitter && (
                      <CustomLink
                        href={member.twitter}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <TwitterIcon sx={{ m: 1, ml: 0 }} fontSize="small" />
                      </CustomLink>
                    )}
                    {member.mail && (
                      <CustomLink href={`mailto:${member.mail}`}>
                        <EmailIcon sx={{ m: 1, ml: 0 }} fontSize="small" />
                      </CustomLink>
                    )}
                  </Box>
                </Card>
              </GridItem>
            );
          })}
        </GridContainer>
      </Box>
    </Layout>
  );
};

export default TeamPage;
